import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const MessageDialog = ({ show, handleClose, messageInfo }) => {
  const [messageData, setMessageData] = useState({ message_title: '', message: '' });

  useEffect(() => {
    let message_title = '';
    if (messageInfo?.message_type === 'success') {
      message_title = 'Success';
    } else if (messageInfo?.message_type === 'error') {
      message_title = 'Error';
    }
    const message = messageInfo?.message || '';

    setMessageData({
      message_title,
      message,
    });
  }, [messageInfo]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{messageData?.message_title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{messageData?.message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageDialog;
